import {
  QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_ERROR,
  QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_REQUEST,
  QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_SUCCESS,
} from "../../Types/user/Types";

const initialState = {
  error: "",
  quick_Action_Run_Upload_With_Fielid_data: "",
  loader: false,
};
const quick_Action_Run_Upload_With_Fielid_Reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_SUCCESS:
      return {
        ...initialState.quick_Action_Run_Upload_With_Fielid_data,
        error: "",
        quick_Action_Run_Upload_With_Fielid_data: action.payload,
        loader: false,
      };
    case QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_ERROR:
      return {
        ...initialState.quick_Action_Run_Upload_With_Fielid_data,
        error: action.error,
        quick_Action_Run_Upload_With_Fielid_data: "",
        loader: false,
      };
    case QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_REQUEST:
      return {
        ...initialState.quick_Action_Run_Upload_With_Fielid_data,
        error: null,
        quick_Action_Run_Upload_With_Fielid_data: "",
        loader: true,
      };
    default:
      return state;
  }
};

export default quick_Action_Run_Upload_With_Fielid_Reducer;
